import Link from 'next/link';
import Image from 'next/image';
import { TeaserProps } from '@/types/componentTypes';
import { useRef } from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

interface TeaserTypeProps {
  datas: TeaserProps;
  styles: string;
  key: number;
}

const Teaser = ({ datas, styles }: TeaserTypeProps) => {
  const ref = useRef(null);

  const imageLoader = ({ src }) => {
    return `${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/${src}`;
  };

  const CustomHeading = ({ children }) => {
    return <h2 className="card-title no-line">{children}</h2>;
  };

  return (
    <div className={`teaser card mb-4 ${styles}`}>
      <Link
        href={datas.link === undefined ? '#' : datas.link}
        ref={ref}
        passHref
        legacyBehavior
      >
        <a title={datas.alt}>
          <div className="card-body">
            <div className="position-relative">
              <Image
                loader={imageLoader}
                src={datas.src}
                alt={datas.alt}
                width={640}
                height={384}
                quality={70}
                className="img-fluid w-100"
                style={{ objectFit: 'cover' }}
              />
            </div>

            <small className="d-inline-block mb-2">{datas.category}</small>

            <ReactMarkdown components={{ h2: CustomHeading }}>
              {datas.title}
            </ReactMarkdown>

            <p>{datas.text}</p>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default Teaser;
